<!-- B 端 · 本店外发结算单 -->
<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="warning"
      :closable="false"
      show-icon
      title="本店外发结算单"
      description="待确认 → 确认后待线下打款。仅待确认可异议作废；待打款请联系平台。货款线下付；登记已打款只勾销台账。预估见「应付供方预估」。"
    />
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" class="!w-140px" clearable>
          <el-option label="待确认" value="PENDING_CONFIRM" />
          <el-option label="待打款" value="PENDING_PAY" />
          <el-option label="已打款" value="PAID" />
          <el-option label="无效" value="INVALID" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="结算单号" prop="no" min-width="170" />
      <el-table-column label="供应商" min-width="120">
        <template #default="{ row }">{{ row.supplierName || row.supplierId }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template #default="{ row }">{{ row.statusName }}</template>
      </el-table-column>
      <el-table-column label="应付供" width="100">
        <template #default="{ row }">{{ fenToYuan(row.payableAmount) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row.id)">详情</el-button>
          <el-button
            v-if="row.status === 'PENDING_CONFIRM'"
            link
            type="success"
            @click="onConfirm(row.id)"
          >
            确认
          </el-button>
          <el-button
            v-if="row.status === 'PENDING_CONFIRM'"
            link
            type="danger"
            @click="onInvalidate(row.id)"
          >
            异议作废
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="loadList"
    />
    <el-drawer v-model="detailVisible" title="结算单详情" size="520px">
      <el-table v-if="detail" :data="detail.items || []" size="small">
        <el-table-column label="订单号" prop="orderNo" min-width="140" />
        <el-table-column label="商品" prop="spuName" min-width="120" />
        <el-table-column label="应付" width="90">
          <template #default="{ row }">{{ fenToYuan(row.payableAmount) }}</template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </ContentWrap>
</template>

<script setup lang="ts">
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  confirmMerchantSettle,
  getMerchantSettle,
  getMerchantSettlePage,
  invalidateMerchantSettle
} from '@/api/mall/trade/supplierSettle'

defineOptions({ name: 'MerchantSupplierSettle' })
const fenToYuan = (fen?: number | null) => ((fen ?? 0) / 100).toFixed(2)

const queryParams = reactive({ pageNo: 1, pageSize: 20, status: undefined as string | undefined })
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const detailVisible = ref(false)
const detail = ref<any>()

const loadList = async () => {
  loading.value = true
  try {
    const data = await getMerchantSettlePage(queryParams)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}
const handleQuery = () => {
  queryParams.pageNo = 1
  loadList()
}
const openDetail = async (id: number) => {
  detail.value = await getMerchantSettle(id)
  detailVisible.value = true
}
const onConfirm = async (id: number) => {
  await ElMessageBox.confirm('确认本结算单金额无误？', '确认')
  await confirmMerchantSettle(id)
  ElMessage.success('已确认')
  loadList()
}
const onInvalidate = async (id: number) => {
  await ElMessageBox.confirm('异议作废后需平台重新出账', '作废', { type: 'warning' })
  await invalidateMerchantSettle(id, '商家异议')
  ElMessage.success('已作废')
  loadList()
}
onMounted(loadList)
</script>
